"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.HeroCarousel = void 0;
var _heroCarousel = _interopRequireDefault(require("./components/hero-carousel"));
exports.HeroCarousel = _heroCarousel["default"];